import store from '../store/store'

export const getActiveCommunity = (user, activeCommunityId = store.getState().user?.active_community_id) => {
  const communities = user?.communities || []

  if (communities.length === 0) {
    return null
  }

  return communities.find((community) => community.id === activeCommunityId) || communities[0]
}

export const getActiveCommunityId = (user) => getActiveCommunity(user)?.id || null

export const postedToCommunityMessage = (user, t) => {
  const activeCommunity = getActiveCommunity(user)

  if ((user?.communities || []).length < 2 || !activeCommunity) {
    return ''
  }

  return t('common.postedToCommunity', { community: activeCommunity.name })
}

export const requiresCommunityChoice = (user, activeCommunityId = store.getState().user?.active_community_id) => {
  const communities = user?.communities || []

  return communities.length > 1 && !communities.some((community) => community.id === activeCommunityId)
}
